import { Card, CardContent, CardHeader, CardTitle } from "@exhousing/design-system";

import { NotesPanel } from "@/components/NotesPanel";
import { ContractTimeline } from "@/components/contract/ContractTimeline";
import { useCostAdjustments } from "@/hooks/api/useCostAdjustments";
import { useIndexations } from "@/hooks/api/useFinance";
import { useDeposit } from "@/hooks/api/useDeposit";
import { useContractInvoices } from "@/hooks/api/useInvoices";
import { useRequirements } from "@/hooks/api/useRequirements";
import { buildTimeline } from "@/lib/contractTimeline";
import type { components } from "@/types/api";

type Contract = components["schemas"]["ContractResponse"];

export function ContractActivity({ contract }: { contract: Contract }) {
  const { data: invoices } = useContractInvoices(contract.id);
  const { data: indexations } = useIndexations(contract.id);
  const { data: deposit } = useDeposit(contract.id);
  const { data: adjustments } = useCostAdjustments(contract.id);
  const { data: requirements } = useRequirements(contract.id);

  const events = buildTimeline(
    contract,
    invoices ?? [],
    indexations ?? [],
    deposit ?? null,
    adjustments ?? [],
    requirements ?? [],
  );

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Activity</CardTitle>
        </CardHeader>
        <CardContent>
          <ContractTimeline events={events} />
        </CardContent>
      </Card>
      <NotesPanel subjectType="contract" subjectId={contract.id} />
    </div>
  );
}
